import React from "react";
import { bottomNavItems } from "../constants";
import { StyledBottomNavContainer ,StyledNavItemsContainer,StyledNavItem} from "./styled";


const BottomNavigation = () => {

    return (
        <StyledBottomNavContainer>
            <StyledNavItemsContainer>
                {React.Children.toArray(bottomNavItems.map((item, index) => (
                    <StyledNavItem key={index} to={item.path} end>
                        <item.icon />
                        <span>{item.name}</span>
                    </StyledNavItem>
                )))}
            </StyledNavItemsContainer>
        </StyledBottomNavContainer>
    )

};

export default BottomNavigation;